import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungMUenchen() {
  return (
    <CityPageTemplate
      city="München"
      slug="muenchen"
      intro="In einer der teuersten Städte Deutschlands ist clevere Finanzplanung besonders wichtig – wir helfen Dir dabei."
      description="Unabhängige & digitale Finanzberatung für München: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
